import {User, UserStatus} from 'store/types';
import {useGlobalAlertModalStore} from 'store/alert';
import {useUserStore} from 'store/user';

// 사용자 상태정보 확인
export const handleUserStatus = async (
    user: User,
    navigate?: (path: string, options?: {replace?: boolean}) => void,
    navigateOptions?: {replace?: boolean},
): Promise<boolean> => {
    if (!user) {
        console.warn('사용자 정보가 없습니다.');
        if (navigate) {
            navigate('/login', navigateOptions);
        } else {
            window.location.replace('/login');
        }
        return false;
    }

    // 계정이 비활성화 된 상태
    if (user.status === UserStatus.SUSPENDED) {
        console.warn('사용자가 정지된 상태입니다:', user.id);
        await useUserStore.getState().logout();

        if (navigate) {
            navigate('/login?error=suspended', navigateOptions);
        } else {
            useGlobalAlertModalStore
                .getState()
                .open('관리자에 의해 비활성화된 계정입니다. 자세한 사항은 고객센터로 문의해주세요.', () => {
                    window.location.replace('/login');
                });
        }
        return false;
    }

    // 계정이 탈퇴 한 상태
    if (user.status === UserStatus.WITHDRAWAL) {
        console.warn('사용자가 탈퇴한 상태입니다:', user.id);
        await useUserStore.getState().logout();

        if (navigate) {
            navigate('/login?error=withdrawal', navigateOptions);
        } else {
            useGlobalAlertModalStore.getState().open('탈퇴된 계정입니다.', () => {
                window.location.replace('/login?error=withdrawal');
            });
        }
        return false;
    }

    // 계정이 대기 상태인 경우 (회원가입 필요)
    if (user.status === UserStatus.WAITING) {
        console.log('사용자가 대기 상태입니다 (회원가입 미완료):', user.id);
        if (navigate) {
            navigate('/signup', navigateOptions);
        }
        return false;
    }

    // 정상 상태 (로그인 완료)
    if (user.status === UserStatus.NORMAL) {
        // 정상 상태에서는 네비게이션을 하지 않고 true만 반환
        // 네비게이션은 호출하는 쪽에서 처리
        return true;
    }

    return false;
};

// 사용자 상태정보 확인 및 처리
export const validateAndHandleUserStatus = async (
    user: User | null,
    navigate?: (path: string, options?: {replace?: boolean}) => void,
    navigateOptions?: {replace?: boolean},
): Promise<boolean> => {
    if (!user) {
        console.warn('사용자 정보가 null입니다.');
        return false;
    }

    return await handleUserStatus(user, navigate, navigateOptions);
};
